import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import Icon from "../atoms/Icon";

import { PageComponentProps } from "../../interfaces/common";

const TicketHeaderView = styled.header`
  position: fixed;
  max-width: 460px;
  width: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  padding: 16px 24px 0 0;
  justify-content: end;
  z-index: 10;

  .back {
    padding: 12px;
    border-radius: 50%;
    display: flex;
    items: center;
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(25px);
  }

  svg {
    width: 20px;
    height: 20px;
    path {
      fill: white;
    }
  }
`;

interface TicketHeaderProps extends PageComponentProps {
  backRoute: string;
}

const TicketHeader: React.FunctionComponent<TicketHeaderProps> = ({
  backRoute,
  idPrefix
}) => {
  return (
    <TicketHeaderView>
      <Link
        to={backRoute}
        data-testid={`${idPrefix}-back-button`}
        className="back"
      >
        <Icon name="close" />
        <span className="ric-hidden">Close</span>
      </Link>
    </TicketHeaderView>
  );
};

export default TicketHeader;
